module.exports = __webpack_public_path__ + "static/img/visual.98941d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/obras_comerciales_secciones/visual.jpg
// module id = G019
// module chunks = 1